import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycProbateAndEstateAdministrationInNewYorkPage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-probate-and-estate-administration-in-new-york/']} />;
}
